import { withoutDomain } from '@experience/shared';
import type { ExtendedForChipsTagType, CityOrRegionTagType } from '@/entities/rubrics';
import type { RegionTagUrls } from '@/shared/api/experience';

export const getUrl = (rubric: CityOrRegionTagType, context: string): string => {
  const baseUrl = rubric?.urls?.[context as keyof RegionTagUrls] || '';
  if (rubric.slug === 'all') {
    return withoutDomain(baseUrl.replace(/all\/$/, ''));
  }

  return withoutDomain(baseUrl);
};

export const getCountryUrl = (context: string, country: string, tag_slug: string): string => {
  return tag_slug === 'all' ? `/${context}/${country}/` : `/${context}/${country}/tags/${tag_slug}/`;
};

/**
 * Строит путь рубрики для городского листинга.
 *
 * Используется как фронтовый источник URL, когда API не возвращает ссылку для туров.
 *
 * @param context вертикаль листинга
 * @param citySlug слаг города
 * @param tagSlug слаг рубрики
 * @returns путь городского листинга с рубрикой или без неё для all
 */
export const getCityUrl = (context: 'tours' | 'excursions', citySlug: string, tagSlug: string): string => {
  const baseUrl = context === 'tours' ? `/tours/city/${citySlug}/` : `/experience/${citySlug}/`;

  return tagSlug === 'all' ? baseUrl : `${baseUrl}${tagSlug}/`;
};

export const extractTagSlugFromRouteParam = (routeTagSlug: string = 'all'): string => {
  return routeTagSlug.replace(/^\d+-/, '');
};

export const createTagIdString = (array: ExtendedForChipsTagType[]) => {
  return array.reduce((acc, tag, index) => {
    if (index === 0) {
      acc = tag.value;
    } else {
      acc += `/ ${tag.value}`;
    }

    return acc;
  }, '');
};
